import type {BioIconProps} from './common-types'

export function Vector({...attributes}: BioIconProps) {
  return (
    <svg width="270" height="264" viewBox="0 0 270 264" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M270 263.798C95.3358 214.718 171.726 92.3198 0 0.797852V239.798C0 253.053 10.7452 263.798 24 263.798H270Z"
        // fill="#7F95FF"
      />
    </svg>
  )
}
